import { useLayout, useMe } from '@/providers'
import IconButton from '@components/IconButton/IconButton'
import { faBars } from '@fortawesome/pro-solid-svg-icons'
import {
	Box,
	AppBar as MUIAppBar,
	Stack,
	Toolbar,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material'

export default function AppBar() {
	const theme = useTheme()
	const me = useMe()
	const { appBarHeight, announcementHeight, setTempSidebarOpen } = useLayout()
	const largeScreen = useMediaQuery(theme.breakpoints.up('sm'))

	const handleOpen = () => {
		setTempSidebarOpen(true)
	}

	if (!largeScreen)
		return (
			<Box>
				<MUIAppBar
					enableColorOnDark
					elevation={0}
					position="fixed"
					sx={{
						backgroundColor: theme.palette.primary.main,
						boxShadow: 'none',
						m: 0,
						border: '0!important',
						paddingX: 2,
						height: appBarHeight,
						top: announcementHeight,
					}}
				>
					<Toolbar
						sx={{
							py: 0,
							pl: '0!important',
							m: 0,
							minHeight: appBarHeight,
							alignItems: 'center',
						}}
					>
						<IconButton
							icon={faBars}
							sx={{ color: theme.palette.common.white }}
							size="large"
							onClick={largeScreen ? null : handleOpen}
						/>
						<Stack
							direction="row"
							width="100%"
							gap={2}
							sx={{
								alignItems: 'center',
								justifyContent: 'flex-end',
								minWidth: '12rem',
							}}
						>
							<Stack direction="row" alignItems="center" gap={2}>
								<Typography variant="h5">{me?.displayName}</Typography>
							</Stack>
						</Stack>
					</Toolbar>
				</MUIAppBar>
			</Box>
		)
}
